// @ts-nocheck
interface ITicketPriority {
  id: number;
  class: string;
  name: string;
}

export enum TaskPriority {
  Urgent = 1,
  High,
  Medium,
  Low,
}

export const ticketPriorities: Array<ITicketPriority> = [
  { id: TaskPriority.Urgent, class: 'urgent-priority', name: 'Urgent' },
  { id: TaskPriority.High, class: 'high-priority', name: 'High' },
  { id: TaskPriority.Medium, class: 'medium-priority', name: 'Medium' },
  { id: TaskPriority.Low, class: 'low-priority', name: 'Low' },
];

export function getClassByPriorityId(priorityId: number): string {
  return ticketPriorities.find((p) => p.id === priorityId)?.class ?? '';
}

export function getNameByPriorityId(priorityId: number): string {
  return ticketPriorities.find((p) => p.id === priorityId)?.name ?? '';
}
